import { SET_THEME } from '../types';

const initialState = {
  themeStatus: 'dark',
};

export default function Caller(state = initialState, action) {
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        themeStatus: action.payload,
      };
    default:
      return state;
  }
}
